module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/title_banner_top-34a0ec7ec1281768c8fc96423261fa83.png";